import React from "react";
import { Box, Flex, Text, Link, HStack } from "@chakra-ui/react";
import { AiOutlineInstagram, AiOutlineYoutube } from "react-icons/ai";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="white"
      width="100%"
      py={8}
      px={8}
    >
      <Box maxWidth="1200px" margin="0 auto">

        {/* Simple Footer */}
        <Flex
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ base: "column", md: "row" }}
          gap={4}
        >
          <Text 
            fontSize="sm" 
            color="black"
            fontFamily="Source Code Pro"
          >
            © 2025 Pablo Ledesma
          </Text>
          
          <HStack spacing={4} alignItems="center">
            <Link 
              href="https://www.instagram.com/algranoconpablo" 
              isExternal 
              aria-label="Instagram"
              color="black"
              _hover={{ color: "gray.600" }}
            >
              <AiOutlineInstagram size="20px" />
            </Link>
            <Link 
              href="https://www.youtube.com/@algranoconPablo" 
              isExternal 
              aria-label="YouTube"
              color="black"
              _hover={{ color: "gray.600" }}
            >
              <AiOutlineYoutube size="20px" />
            </Link>
          </HStack>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;